import React,{useState} from 'react';
import './RVWiframe.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import FullscreenLoader from '../FullscreenLoader';
import { queuedApiFetch, apiFetch } from '../api';
const MySwal = withReactContent(Swal);
const formData = new FormData();

function RVWiframe() {

  const [activeDiv, setActiveDiv] = useState('');
  const accountId = localStorage.getItem('accountId');
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);  
  const defaultProjectNumber = selectedProjectDetail.projectNumber; 
    //new code updations
      const getUserDetails = localStorage.getItem('userDetails');
      const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
      const userId = userDetails ? userDetails.id : '';
      const getUserAccess = userDetails ? userDetails.access_level : '';
      const [userCompany, setUserCompany] = useState();
      const getUserCompanyDetails =userCompany;
      const getUserEmail = localStorage.getItem('userEmail');
      const [userPermission, setUserPermission] = useState();
      const [loading, setLoading] = useState(false);

      const fetchUserCompany = async () => {
        const requestOptions = {
          method: 'GET',
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };
         try {
          const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
            setUserCompany(data.data.company_name);
            setUserPermission(data.data.access_level);     
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false); // End loading
        }
      }
      const fetchData = async () => {
        try {
            await fetchUserCompany();
            
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

  let parametervalue = 0;

  //Parameter passing
  if (getUserCompanyDetails === "NUS") {
    parametervalue = 1;
  } else {
    parametervalue = 0;
  }

  let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
  let p_roles = selectedProjectDetail?.Proj_Access?.proj_role.join(", ");
  let proj_name=selectedProjectDetail?.projectName;

  let qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;

  const NEW_RVW = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/ae5f13a5-a192-557a-b955-2884c9b5bf1c/reports/23ed2785-73b6-4f44-b059-489c48be0aaf?${qs_params}`;
  const IPA_URL = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/3ce03826-6156-545d-85be-88ad82b5a389/reports/700a0a57-0ded-419a-96ca-585d8b0a2b38?${qs_params}`;
  const SUP_RVW = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/ae5f13a5-a192-557a-b955-2884c9b5bf1c/reports/23ed2785-73b6-4f44-b059-489c48be0aaf?${qs_params}`;


  const supersedeRVWPopup = () => {
    MySwal.fire({
      title: '',
      html: `
                  <div class="popup-container">        
                <div class="popup-body">

                <div class="popup-field">
                  <label for="RVWNumber">RVW / IPA number *</label>
                  <select id="RVWNumber" style="width: 220px; border-radius: 0;" class="popup-input">
                  <option value="" selected>Select RVW / IPA number</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                </div>                     
                </div>
              </div>
                `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
        cancelButton: 'cancel-button',
        confirmButton: 'bond-confirm-button',
        actions: 'custom-actions',
      },
      reverseButtons: false,
      allowOutsideClick: false,
      preConfirm: () => {
        return;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Project created successfully!');
      }
    }).catch((errorMessage) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    });
  };



  const t_apply_new_rvw='RVW';
  const t_apply_ipa='RVW (IPA)';
  const t_apply_ss_rvw='RVW';

  const handleClick = (id) => {
    setActiveDiv(id);
  };

  // const submitForm = (template_name, formData, menu) => {
  //   const form = document.createElement('form');
  //   form.method = 'POST';
  //   //form.action = actionUrl;
  //   form.action = `${process.env.REACT_APP_BACKEND_URL}/form_template/form_post`;
  
  //    formData.append('account_id', accountId);
  //    formData.append('project_id', defaultProjectNumber);
  //    //added 2 parameters for the url
  //    formData.append('menu', menu);
  //    formData.append('nususer', parametervalue);
  
  //   formData.append('template_name', template_name);
  //   // form.enctype = 'multipart/form-data'; // Required for file uploads
  
  //   // Append FormData fields as hidden inputs
  //   for (const [key, value] of formData.entries()) {
  //       const input = document.createElement('input');
  //       input.type = 'hidden';
  //       input.name = key;
  //       input.value = value;
  //       form.appendChild(input);
  //   }
  
  //   document.body.appendChild(form);
  //   form.submit();
  // };

  const supersede = () => {
    MySwal.fire({
      title: '',
      html: `
            <div class="popup-container" style="padding:0 !important;">        
          <div class="popup-body">
          
          <div class="popup-field">
            <label for="RVWNumber">Supersede RVW Number *</label>
            <select id="RVWNumber" style="width: 200px; border-radius: 0;" class="popup-input">
            <option value="" selected>Select RVW No. to supersede</option>
            </select>
          </div>                     
          </div>
        </div>
          `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
        cancelButton: 'cancel-button',
        confirmButton: 'bond-confirm-button',
        actions: 'custom-actions',
      },
      reverseButtons: false,
      allowOutsideClick: false,
      didOpen: async () => {

    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = JSON.parse(getProjectDetails);
    const projectNum = selectedProjectDetail.projectNumber;
    //const projectName = selectedProjectDetail.projectName;
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
    //const company_id = userDetails ? userDetails.default_company_id : '';
    const user_id = userDetails ? userDetails.id : '';  
    const autodesk_id = userDetails ? userDetails.autodesk_id : '';        
    
        try {
          Swal.showLoading();

          const requestOptions = {
            method: 'GET',
            // headers: {
            //   'Content-Type': 'application/json',
            //   'ngrok-skip-browser-warning': '69420',
            // },
      
          };

          const response = await queuedApiFetch(`/payment/rvw_nos?project_id=${projectNum}&email_id=${getUserEmail}`, requestOptions);
          const result = await response;

          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {    
  
  var select1 = document.getElementById('RVWNumber');
  
  for(var i = 0; i < result.data.length; i++)
  {
    const option = document.createElement("option");
    // option.textContent = result.data[i];
    // option.value = result.data[i];
     option.textContent = result.data[i].rvw_type +" "+result.data[i].rvw_no;
    option.value = result.data[i].rvw_no;
    select1.appendChild(option);
  };         
         setLoading(false);
        Swal.hideLoading();         
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false;
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false;
        }
      },
      preConfirm: async () => {
        
        const RVWNumber = document.getElementById('RVWNumber').value;

        if (!RVWNumber) {
          Swal.showValidationMessage('Please Select Supersede RVW Number');
          return false;
        }
        //setLoading(true);

        formData.append('supersede', 's');
        formData.append('rvw_no', RVWNumber);

        window.submitform(t_apply_ss_rvw,formData,'Construction_Submit RVW_Apply for RVW_Apply to supersede RVW');

        //#region Supersede update
        // const sendData = {          
        //   project_id: defaultProjectNumber,
        //   RVW_No: RVWNumber
        // };

        // // console.log('sendData....',sendData);
        
        // try {
        //   Swal.showLoading();

        //   const requestOptions = {
        //     method: 'POST',
        //     // headers: {
        //     //   'Content-Type': 'application/json',
        //     //   'ngrok-skip-browser-warning': '69420',
        //     // },
        //     body: JSON.stringify(sendData),
        //   };

        //   const response = await queuedApiFetch('/payment/supersede_rvw', requestOptions);
        //   const result = await response;

        //   if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {            
        //     // showToast.success('Project Created Successfully');
        //     // return true; // Close the popup
        //    // console.log(SOI_URL);
        //    //window.location.href = SOI_URL;
        //    window.submitform(t_apply_ss_rvw,formData,'Construction_Submit RVW_Apply for RVW_Apply to supersede RVW');
        //   } else {
        //     Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
        //     return false;
        //   }
        // } catch (error) {
        //   console.error('Error saving data:', error);
        //   Swal.showValidationMessage('Something went wrong. Please try again.');
        //   return false;
        // }
        //#endregion
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('RVW Superseded successfully..');
      }
      
    }).catch((errorMessage) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
      setLoading(false);
        Swal.hideLoading();  
    });
  };

  const rvw_form = (temp_name, menu) => {
    // Remove old keys
    formData.delete('supersede');
    formData.delete('rvw_no');
    window.submitform(temp_name, formData, menu);
  };

  return (
    // <html>
    // <body style={{display: "flex", justifyContent: "center", alignItems: 'center', margin: 0, width:"230%", background: "#f0f0f0", height: "80vh"}}>     
  
    // </body>
    // </html>
     <div className="rvw-container">
      {loading && <FullscreenLoader />} 
     <div style={{width: "100%"}}>
     <div className="rvw-header">Please select from below</div>
      <div className="rvw-button-group">
          {/* <div className={`rvw-button ${activeDiv === "new" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("new"); window.location.href = NEW_RVW}}>Apply for New RVW</div>
          <div className={`rvw-button ${activeDiv === "ipa" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("ipa"); window.location.href =IPA_URL}}>Apply for IPA</div>
          <div className={`rvw-button ${activeDiv === "rvw" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("rvw"); window.location.href =SUP_RVW}}>Apply to supersede RVW</div> */}
          {/* <div className={`rvw-button ${activeDiv === "new" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("new"); window.submitform(t_apply_new_rvw,formData,'Construction_Submit RVW_Apply for RVW_Apply for New RVW');}}>Apply for New RVW</div>
          <div className={`rvw-button ${activeDiv === "ipa" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("ipa"); window.submitform(t_apply_ipa,formData,'Construction_Submit RVW_Apply for RVW_Apply for IPA');}}>Apply for New RVW(IPA)</div> */}

          <div className={`rvw-button ${activeDiv === "new" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("new"); rvw_form(t_apply_new_rvw,'Construction_Submit RVW_Apply for RVW_Apply for New RVW');}}>Apply for New RVW</div>
          <div className={`rvw-button ${activeDiv === "ipa" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("ipa"); rvw_form(t_apply_ipa,'Construction_Submit RVW_Apply for RVW_Apply for IPA');}}>Apply for New IPA</div>
            {/* Apply for New RVW(IPA) */}
          {/* <div className={`rvw-button ${activeDiv === "rvw" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("rvw"); window.submitform(t_apply_ss_rvw,formData,'Construction_Submit RVW_Apply for RVW_Apply to supersede RVW');}}>Apply to supersede RVW</div> */}
          {/*<div className={`rvw-button ${activeDiv === "rvw" ? "button-blue" : "button-gray"}`} onClick={() => {supersedeRVWPopup();}}>Apply to supersede RVW</div>*/}
          <div className={`rvw-button ${activeDiv === "rvw" ? "button-blue" : "button-gray"}`} onClick={() => {handleClick("rvw"); setLoading(true); supersede();}}>Apply to close IPA / Supersede RVW</div>
      </div>
     </div>
  </div>
  );
}

export default RVWiframe;
